import { Injectable } from '@angular/core';
import { FunctionLifeCycle } from '../telephonyutils';
import { InsightProvider, MessagingProvider, TelephonyProvider, VoiceProvider } from '../telephony.provider';
import { TwilioMessagingProvider } from './twilio.messaging.provider';
import { TwilioVoiceProvider } from './twilio.voice.provider';
import { TwilioInsightProvider } from './twilio.insight.provider';

@Injectable({ providedIn: 'root' })
export class TwilioTelephonyProvider extends TelephonyProvider {
  constructor(private _messaging: TwilioMessagingProvider,
    private _voice: TwilioVoiceProvider,
    private _insight: TwilioInsightProvider) {
    super();
  }

  override name(): string {
    return 'twilio';
  }
  override get messaging(): MessagingProvider {
    return this._messaging;
  }

  override get voice(): VoiceProvider {
    return this._voice;
  }

  override get insight(): InsightProvider {
    return this._insight;
  }
  override init(lf: FunctionLifeCycle): void {
    lf?.onStart();

    console.log(new Date().toLocaleString() + '  ➤  Twilio');

    lf?.onEnd();
  }
}
